export type MenuCategory = 'tourtes' | 'street' | 'accompagnements' | 'boissons'

export interface MenuItem {
  id: string
  name: string
  origin: string
  description: string
  price: number
  category: MenuCategory
  image?: string
  tags?: string[]
  soldOut?: boolean
}

export const categories: { id: MenuCategory; label: string; hint: string }[] = [
  { id: 'tourtes', label: 'Tourtes du monde', hint: 'Faites maison, pâte pur beurre' },
  { id: 'street', label: 'Street food', hint: 'À manger sur le pouce' },
  { id: 'accompagnements', label: 'Accompagnements', hint: 'Pour compléter' },
  { id: 'boissons', label: 'Boissons', hint: 'Fraîches & locales' },
]

export const menu: MenuItem[] = [
  {
    id: 'tourte-argentine',
    name: 'La Buenos Aires',
    origin: 'Argentine',
    description: 'Bœuf mijoté, olives, œuf, cumin. La empanada revisitée en grand format.',
    price: 9.5,
    category: 'tourtes',
    image: 'https://cdn.magicpatterns.com/uploads/fFfdPrzf4ZAAM82UQE81hT/1000003465.jpg',
    tags: ['Best-seller'],
  },
  {
    id: 'tourte-louisiane',
    name: 'La Nouvelle-Orléans',
    origin: 'Louisiane',
    description: 'Écrevisses, saucisse fumée, maïs doux, épices cajun maison.',
    price: 11,
    category: 'tourtes',
    image: 'https://cdn.magicpatterns.com/uploads/wVqTRsNcF6f5fBnhRnb7vw/1000000075.jpg',
    tags: ['Épicé'],
  },
  {
    id: 'tourte-angleterre',
    name: 'La London',
    origin: 'Angleterre',
    description: 'Poulet rôti, poireaux, sauce crémeuse au cheddar affiné.',
    price: 9.5,
    category: 'tourtes',
  },
  {
    id: 'tourte-cuba',
    name: 'La Havana',
    origin: 'Cuba',
    description: 'Porc effiloché mojo, cornichons, moutarde jaune, emmental.',
    price: 10,
    category: 'tourtes',
  },
  {
    id: 'tourte-hawai',
    name: 'La Honolulu',
    origin: 'Hawaï',
    description: 'Poulet teriyaki, ananas rôti, oignons nouveaux.',
    price: 9.5,
    category: 'tourtes',
    soldOut: true,
  },
  {
    id: 'tourte-veggie',
    name: 'La Marrakech',
    origin: 'Maroc',
    description: 'Pois chiches, patate douce, ras-el-hanout, coriandre fraîche.',
    price: 9,
    category: 'tourtes',
    tags: ['Végé'],
  },
  {
    id: 'hotdog-chorizo',
    name: 'Le Choripán',
    origin: 'Argentine',
    description: 'Chorizo grillé, pain sésame, chimichurri maison.',
    price: 7.5,
    category: 'street',
    image: 'https://cdn.magicpatterns.com/uploads/jRNfZTfuyr2zdLbgD3Wavk/1000002154.jpg',
    tags: ['Best-seller'],
  },
  {
    id: 'quesadilla',
    name: 'Quesadilla del barrio',
    origin: 'Mexique',
    description: 'Tortilla de blé, bœuf haché épicé, cheddar fondu.',
    price: 8,
    category: 'street',
    image: 'https://cdn.magicpatterns.com/uploads/pf7bDWxt4Hg2QdEZZtFdQ5/1000001746.jpg',
  },
  {
    id: 'frites',
    name: 'Frites fraîches',
    origin: 'Ici',
    description: 'Pommes de terre du coin, coupées et frites sur place.',
    price: 3.5,
    category: 'accompagnements',
  },
  {
    id: 'salade',
    name: 'Salade du marché',
    origin: 'Ici',
    description: 'Jeunes pousses, vinaigrette à l’huile de noix.',
    price: 3,
    category: 'accompagnements',
  },
  {
    id: 'limonade',
    name: 'Limonade artisanale',
    origin: 'Ici',
    description: '33 cl — citron ou gingembre.',
    price: 3,
    category: 'boissons',
  },
  {
    id: 'biere',
    name: 'Bière locale',
    origin: 'Ici',
    description: '33 cl — blonde ou ambrée de brasserie voisine.',
    price: 4.5,
    category: 'boissons',
  },
]
